import { createApp } from 'vue'
import App from './Index.vue'

createApp(App).mount('#app-index')
